import { opacity } from "@cloudinary/url-gen/actions/adjust";
import zIndex from "@mui/material/styles/zIndex";
import React, { useState, useEffect, useCallback, useContext } from "react";

// Переименованный компонент Footer, который будет фиксирован внизу экрана
export const Footer = ({ children }) => {
  return <div style={styles.footerContainer}>{children}</div>;
};

// Стили для компонента
const styles = {
  footerContainer: {
    zIndex: 9999,
    maxHeight: "100px",
    position: "fixed", // Фиксируем компонент
    bottom: 0, // Прижимаем к нижней части экрана
    left: 0, // Растягиваем на всю ширину
    width: "100%", // Ширина 100%
    backgroundColor: "#131415", // Цвет фона
    padding: "10px", // Внутренний отступ
    boxShadow: "0 -2px 10px rgba(0, 0, 0, 0.1)", // Тень сверху для разделения
    display: "flex", // Гибкая раскладка для размещения кнопок
    justifyContent: "center", // Центрируем содержимое
    opacity: "95%",
  },
};
